import { keyframes } from '@emotion/react';
import { Stack, styled } from '@mui/material';

export const QRCode = styled(Stack)(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  width: '38px',
  height: '38px',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main
  },
  '& img': {
    [`${theme.breakpoints.down('sm')}`]: {
      backgroundColor: theme.palette.secondary.main
    }
  }
}));

export const QrHover = styled(Stack)<{ isVisible: boolean }>(
  ({ isVisible }) => ({
    marginLeft: '12%',
    alignItems: 'end',
    display: isVisible ? 'flex' : 'none'
  })
);

export const QrHeader = styled(Stack)(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: '50%',
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  width: '38px',
  height: '38px',
  border: '1px solid',
  outline: 'none',
  borderColor: theme.palette.grayBackground.A40
}));

export const hideMenuAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
`;
